import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "../../../../../../shared/const/localstorage";


export const printActsPdf = createAsyncThunk(
    "account/downloadPdf",
    async (actId: number, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }

            const { token } = JSON.parse(authToken);

            const response = await axios.get(`/api/payments/acts-pdf/${actId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: "blob",
            });

            if (!response.data) {
                throw new Error("Response data is empty");
            }

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            return url;
        } catch (error) {
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);
